import { useState } from 'react';
import { fetchWithAuth } from './authHelpers';

export const useClutchPicks = () => {
    const [clutchPicks, setClutchPicks] = useState([]);
    const [tokenLastUsed, setTokenLastUsed] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [fastForwardLoading, setFastForwardLoading] = useState(false);
    const [fastForwardError, setFastForwardError] = useState(null);

    const fetchClutchPicks = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/clutch-picks`, 'GET');
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch clutch picks');
            }
            const data = await response.json();
            setClutchPicks(data.clutchPicks || []);
            setTokenLastUsed(data.tokenLastUsed || null);
            console.log('Clutch picks fetched successfully:', data);
            return data;
        } catch (err) {
            setError(err.message);
            setClutchPicks([]);
            return null;
        } finally {
            setLoading(false);
        }
    };

    // Open a clutch pick by ID
    const openClutchPick = async (clutchPickId) => {
        setError(null);
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/clutch-picks/open`, 'POST', { clutchPickId });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Failed to open clutch pick');
            }
            // Optionally, refresh clutch picks after opening
            await fetchClutchPicks();
            return data;
        } catch (err) {
            setError(err.message);
            return null;
        }
    };

    // Get fast forward price for clutch pick token
    const getFastForwardPrice = async () => {
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/clutch-picks/fast-forward-price`, 'GET');
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Failed to get fast forward price');
            }
            return data;
        } catch (err) {
            console.error('Error getting fast forward price:', err.message);
            return null;
        }
    };

    // Fast forward clutch pick token
    const fastForwardClutchPickToken = async () => {
        setFastForwardLoading(true);
        setFastForwardError(null);
        try {
            const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/clutch-picks/fast-forward`, 'POST', {});
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Failed to fast forward token');
            }
            // Optionally, refresh clutch picks after fast forward
            await fetchClutchPicks();
            return data;
        } catch (err) {
            setFastForwardLoading(false);
            setFastForwardError(err.message);
            return null;
        } finally {
            setFastForwardLoading(false);
        }
    };

    return { clutchPicks, tokenLastUsed, fetchClutchPicks, openClutchPick, getFastForwardPrice, fastForwardClutchPickToken, loading, error, fastForwardLoading, fastForwardError };
};
